export default "__VITE_ASSET__C4Av5cMt__"